import { Clickable, Col, H2, H3, Image, P, Row, Section, TypeWrapper, Wrapper } from '@ahmdigital/ui';
import { FC } from 'react';
import { map } from 'lodash/fp';
import styled from 'styled-components';

import { focusVisible } from '../branch';
import { UrlObject } from '../../../../types/__codegen__/sanity/graphql';
import { URLS } from '../../../../models/url/constants';

const SubHeading = styled(H2)`
  ${focusVisible}
`;

const StyledSection = styled(Section)`
  padding: 4rem 0.75rem;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    padding: 5.5rem 1rem;
  }

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 7.5rem 1rem;
  }
`;

const BreakTagHiddenMobile = styled.br`
  display: none;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    display: block;
  }
`;

const ImageColumn = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  order: 1;
  padding: 2.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    order: 0;
  }
`;

const Link = styled(Clickable)`
  width: 100%;
  padding: 1.25rem 0;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.grey20};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    transform: scaleX(0.99);
    transition: transform 0.1s ease-in-out;
    transform-origin: left;

    &:hover {
      transform: scaleX(1);
      border-bottom: 2px solid ${({ theme: { colors } }) => colors.grey70};
    }
  }
`;

const subHeadingLine1 = 'Manage your cover online when it suits you.';
const subHeadingLine2 = 'Don’t have an account?';
const linkText = 'Register';

export type QueryTypeProps = Readonly<{
  links: ReadonlyArray<
    {
      inNewTab?: boolean;
    } & UrlObject
  >;
  image: {
    src: string;
  };
  scrollTo?: string;
  title: string;
}>;

const QueryType: FC<QueryTypeProps> = ({ links, image, title }) => (
  <StyledSection variant="regular">
    <TypeWrapper variant="center">
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
      <SubHeading variant="marginBottomSpacer9" id={title} tabIndex="0">
        {title}
      </SubHeading>
      <H3 looksLike="h5" variant={['regular', 'marginBottomSpacer10']}>
        {subHeadingLine1} <BreakTagHiddenMobile />
        {subHeadingLine2}{' '}
        <Clickable aria-label={`${subHeadingLine1} ${subHeadingLine2} ${linkText}`} to={URLS.MEMBERS.REGISTRATION}>
          {linkText}
        </Clickable>
      </H3>
    </TypeWrapper>
    <Wrapper>
      <Row variant="marginTopSpacer7">
        <ImageColumn df={6} sm={12} variant={['paddingTopSpacer7', 'paddingBottomSpacer7']}>
          {image && <Image src={image.src} role="presentation" />}
        </ImageColumn>
        <Col df={6} sm={12}>
          {map(
            ({ inNewTab = true, name, url }) => (
              <Row key={name} variant="marginBottomSpacer10">
                <Link
                  icon={{ name: 'arrow-right-long', position: 'right' }}
                  inNewTab={inNewTab}
                  isUnstyled
                  // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
                  to={url}
                  variant="wideSpaceBetween"
                >
                  <P looksLike="h5">{name}</P>
                </Link>
              </Row>
            ),
            links,
          )}
        </Col>
      </Row>
    </Wrapper>
  </StyledSection>
);

export default QueryType;
